// removed by extract-text-webpack-plugin
module.exports = {"SortList":"_2JFWruxgIgTOVX9GzojsxN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SortList/SortList.css
// module id = 305
// module chunks = 8